import useBeneficiaryAccess from '@UI/Hooks/useBeneficiaryAccess';

/** `true` once the caller's level on the beneficiary type allows reading its dossiers. */
const useCanReadBeneficiaries = (): boolean => useBeneficiaryAccess().access?.canRead === true;

export default useCanReadBeneficiaries;
